import { UseMutationOptions, useMutation } from '@tanstack/react-query';
import axiosInstance, { getAPIURL } from '../axiosInstance';

interface DeleteProps {
  id: number;
  objectId: string;
}

export const useCancelConnectionRequest = (
  options?: UseMutationOptions<unknown, Error, DeleteProps, unknown>
) => {
  return useMutation<unknown, Error, DeleteProps>({
    ...options,
    mutationFn: async ({ id, objectId }: DeleteProps) => {
      const response = await axiosInstance.delete(
        getAPIURL(`/User/deleteConnectionRequest/${objectId}/${id}`)
      );
      return response.data;
    },
  });
};
